export default __webpack_public_path__ + "static/media/Group -12@2x.0b6fcdf4.png";